import React from "react";

// Admin Imports
import Dashboard from "views/admin/default";
import TicketList from "views/admin/tickets";
import TicketDetails from "views/admin/tickets/components/TicketDetails";
import Profile from "views/admin/profile";
import Users from "views/admin/users";
import Home from "views/frontend/index";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import { MdHome, MdPerson, MdLock } from "react-icons/md";
import { HiOutlineTicket } from "react-icons/hi2";
import HotelList from "views/frontend/HotelList";
import HotelDetail from "views/frontend/HotelDetail";

const routes = [
  {
    name: "Frontend Dashboard",
    layout: "/customer",
    path: "/",
    icon: <MdHome className="h-6 w-6" />,
    component: <Home />,
    showInSidebar: false,
    allowedRoles: ["customer"],
  },
  {
    name: "Hotel Lists",
    layout: "/customer",
    path: "hotels",
    icon: <MdHome className="h-6 w-6" />,
    component: <HotelList />,
    showInSidebar: false,
    allowedRoles: ["customer"],
  },
  {
    name: "Hotel Details",
    layout: "/customer",
    path: "hotels/:id",
    icon: <MdHome className="h-6 w-6" />,
    component: <HotelDetail />,
    showInSidebar: false,
    allowedRoles: ["customer"],
  },
  {
    name: "Dashboard",
    layout: "/admin",
    path: "dashboard",
    icon: <MdHome className="h-6 w-6" />,
    component: <Dashboard />,
    showInSidebar: true,
    allowedRoles: ["admin"],
  },
  {
    name: "Tickets",
    layout: "/admin",
    path: "tickets",
    icon: <HiOutlineTicket className="h-6 w-5" />,
    component: <TicketList />,
    secondary: true,
    showInSidebar: true,
    allowedRoles: ["admin", "agent"],
  },
  {
    name: "Ticket",
    layout: "/admin",
    path: "tickets/:id",
    component: <TicketDetails />,
    showInSidebar: false,
    allowedRoles: ["admin", "agent"],
  },
  {
    name: "Users",
    layout: "/admin",
    path: "users",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Users />,
    showInSidebar: true,
    allowedRoles: ["admin"],
  },
  {
    name: "User Profile",
    layout: "/admin",
    path: "users/:id",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
    showInSidebar: false,
    allowedRoles: ["admin"],
  },
  {
    name: "Profile",
    layout: "/profile",
    path: "",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
    showInSidebar: false,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
    showInSidebar: false,
  },
];
export default routes;
